import i18next from 'i18next'
import {useEffect, useState} from 'react'
import {Accordion, Button, Col, Form, Modal, Row} from 'react-bootstrap'
import {useTranslation} from 'react-i18next'
import Skeleton from 'react-loading-skeleton'
import {fetchHistorySIP} from 'src/services/fetcher'
import dateformat from 'src/utils/dateformat'
import swal from 'sweetalert'
import Editor from 'src/app/components/Editor'
import * as TableUI from '../../../components/Table/Table'
import {BadgeColorSIP} from 'src/components/BadgeColorSIP'
import {PopoverText} from 'src/components'
import {PriceFormater} from 'src/components/mikro/PriceFormater'

type Prop = {
  id: number
  setShowListHistorySIP: any
  showListHistorySIP: any
}

const ListHistorySIP: React.FC<Prop> = ({id, setShowListHistorySIP, showListHistorySIP}) => {
  const [isLoading, setIsLoading] = useState(false)
  const [historySIP, setHistorySIP] = useState<any>([])
  const {t} = useTranslation()

  const getEndUser = (data: any) => data.end_user.replace(/,/g, ', ')

  useEffect(() => {
    if (id) {
      setIsLoading(true)
      fetchHistorySIP(id)
        .then((res: any) => {
          setHistorySIP(res.data.data)
        })
        .catch((err) => {
          swal({
            closeOnClickOutside: false,
            title: t(err.response.data.message),
            icon: 'error',
          })
        })
        .finally(() => {
          setIsLoading(false)
        })
    }
  }, [id])

  return (
    <>
      <Modal
        show={showListHistorySIP}
        onHide={() => {
          setShowListHistorySIP(false)
        }}
        backdrop='static'
        keyboard={false}
        centered
        scrollable
        size='xl'
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('Histories SIP')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {isLoading ? (
            <Skeleton width={100} height={30} />
          ) : (
            <>
              <Accordion>
                {historySIP.map((data: any, _index: any) => (
                  <>
                    <Accordion.Item eventKey={data?.id}>
                      <Accordion.Header>
                        <span>
                            {_index == historySIP.length - 1 ? t('created-by') : t('changed-by')}{' '}
                            <b>{data?.user?.name}</b> - {dateformat((_index == 0 ? data.updated_at : data.created_at), {showtime: true})}{' '}
                            {_index == 0
                            ? ` (${t('current')})`
                            : [1, 2].includes(data?.flag)
                            ? ` (${t('Amendment')})`
                            : ''}
                        </span>
                      </Accordion.Header>
                      <Accordion.Body style={{backgroundColor: 'white'}}>
                        <>
                          <Row>
                            <Col md={6}>
                              <Row className='mb-3'>
                                <Col md={4}>
                                  <p className='fs-4 mt-2'>{t('sip-number')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    type='text'
                                    defaultValue={`11${data?.SIP_number}`}
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-3'>
                                <Col md={4}>
                                  <p className='fs-4 mt-2'>{t('Customer Name')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    type='text'
                                    value={`${
                                      data?.customer?.title ? `${data?.customer?.title} ` : ''
                                    }${data?.customer?.name}`}
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-3'>
                                <Col md={4}>
                                  <p className='fs-4 mt-2'>{t('Assigner Name')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    type='text'
                                    value={data?.signer_name}
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-3'>
                                <Col md={4}>
                                  <p className='fs-4 mt-2'>{t('Start-Date')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    type='text'
                                    defaultValue={dateformat(data?.valid_date_from)}
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>

                              <Row className='mb-3'>
                                <Col md={4} className='d-flex align-items-center'>
                                  <p className='fs-4'>{t('Tanggal Pengajuan SIP')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    type='text'
                                    defaultValue={dateformat(data?.estimate_date)}
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-3'>
                                <Col md={4} className='d-flex align-items-center'>
                                  <p className='fs-4'>{t('kepada')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    type='text'
                                    defaultValue={data?.kepada}
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                            </Col>
                            <Col md={6}>
                              <Row className='mb-3'>
                                <Col md={4}>
                                  <p className='fs-4 mt-2'>{t('Customer Number')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    type='text'
                                    value={data?.customer_id}
                                    placeholder={t('Customer Number')}
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-3'>
                                <Col md={4}>
                                  <p className='fs-4 mt-2'>{t('Assigner Position')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    type='text'
                                    value={data?.signer_position}
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-3'>
                                <Col md={4}>
                                  <p className='fs-4 mt-2'>{t('End-Date')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    type='text'
                                    defaultValue={dateformat(data?.valid_date_to)}
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-3'>
                                <Col md={4} className='d-flex align-items-center'>
                                  <p className='fs-4'>{t('Metode Pembayaran')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    style={{height: '40px'}}
                                    value={data?.payment_method_info || '-'}
                                    disabled
                                    size='sm'
                                  />
                                </Col>
                              </Row>

                              <Row className='mb-3'>
                                <Col md={4}>
                                  <p className='fs-4 mt-2'>{t('order-perihal')}</p>
                                </Col>
                                <Col md={8}>
                                  <Form.Control
                                    aria-label='Default select example'
                                    size='sm'
                                    value={t('penjualan')}
                                    disabled
                                  />
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                          <hr />
                          <>
                            <Form.Group className='mb-10' controlId='formBasicPassword'>
                              <p className='fs-4 mt-2'>Body</p>
                              <Editor
                                disabled={true}
                                data={data?.body_content}
                                onChange={(content) => false}
                              />
                            </Form.Group>

                            <Form.Group className='mb-10' controlId='formBasicPassword'>
                              <p className='fs-4 mt-2'>{t('Lain-lain')}</p>
                              <Editor
                                disabled={true}
                                data={data?.lain_lain}
                                onChange={(content) => false}
                              />
                            </Form.Group>

                            <Form.Group className='mb-10' controlId='formBasicPassword'>
                              <p className='fs-4 mt-2'>Footer</p>
                              <Editor
                                disabled={true}
                                data={data?.footer_content}
                                onChange={(content) => false}
                              />
                            </Form.Group>
                          </>
                          <hr />
                          <>
                            <p className='fs-4 mt-2'>{t('Item')}</p>
                            <div className='table-responsive bdr'>
                              {/* Table Head */}
                              <TableUI.TableDetail colSpan={14}>
                                <TableUI.TableWrapper style={{marginBottom: 0}}>
                                  <TableUI.Table>
                                    <TableUI.THead>
                                      <tr style={{backgroundColor: '#274070'}}>
                                        <th>{t('kontrak-item')}</th>
                                        <th>Sales Org</th>
                                        <th>{t('kontrak-incoterm')}</th>
                                        <th>{t('kontrak-wilayah')}</th>
                                        {data?.sector_id == 1 && <th>{t('segment')}</th>}
                                        <th>{t('sub-order-endUser')}</th>
                                        {data?.sector_id == 2 && <th>{t('Sektor')}</th>}
                                        <th>{t('kontrak-jenis')}</th>
                                        <th>{t('Product Code')}</th>
                                        <th>{t('kontrak-nama')}</th>
                                        <th>{t('kontrak-spek')}</th>
                                        <th>{t('Kuantum Pengajuan')}</th>
                                        {data?.sector_id != 2 && <th>{t('sub-order-kuantumD')}</th>}
                                        <th>{t('sub-order-hargaP')}</th>
                                        {data?.sector_id != 2 && <th>{t('sub-order-hargaD')}</th>}
                                      </tr>
                                    </TableUI.THead>
                                    <TableUI.TBody>
                                      {data?.order_sub_details?.map((item: any, index: number) => {
                                        return (
                                          <tr key={item?.id ?? index}>
                                            <td>
                                              <span className='d-block fs-6 py-3'>{index + 1}</span>
                                            </td>
                                            <td>
                                              <span className='d-block fs-6 py-3'>
                                                {item.produsen?.name}
                                              </span>
                                            </td>
                                            {item?.sector_id == 2 ? (
                                              <>
                                                {item?.incoterm2 == null ? (
                                                  <td>
                                                    <span className='d-block fs-6 py-3'>
                                                      {item?.incoterm1?.code}-{item?.incoterm2_id}
                                                    </span>
                                                  </td>
                                                ) : (
                                                  <td>
                                                    <span className='d-block fs-6 py-3'>
                                                      {item?.incoterm1?.code}-
                                                      {item?.incoterm2?.code}
                                                    </span>
                                                  </td>
                                                )}
                                              </>
                                            ) : (
                                              <>
                                                {item?.incoterm2 == null ? (
                                                  <td>
                                                    <span className='d-block fs-6 py-3'>
                                                      {item?.incoterm1?.code}
                                                      {item?.incoterm2_id == null ||
                                                      item?.incoterm2_id == '0'
                                                        ? ''
                                                        : '-' + item?.incoterm2_id}
                                                    </span>
                                                  </td>
                                                ) : (
                                                  <td>
                                                    <span className='d-block fs-6 py-3'>
                                                      {item?.incoterm1?.code}-
                                                      {item?.incoterm2?.code}
                                                    </span>
                                                  </td>
                                                )}
                                              </>
                                            )}
                                            <td>
                                              <span className='d-block fs-6 py-3'>
                                                <PopoverText
                                                  content={
                                                    item?.province?.region_name ||
                                                    '' +
                                                      (item?.city?.city_name
                                                        ? ', ' + item?.city?.city_name
                                                        : '')
                                                  }
                                                  index={index}
                                                  className='spec-sliceee'
                                                />
                                              </span>
                                            </td>
                                            {item?.sector_id == 1 ? (
                                              <td>
                                                <span className='d-block fs-6 py-3'>
                                                  {t(item.segment_name)}
                                                </span>
                                              </td>
                                            ) : (
                                              ''
                                            )}
                                            <td>
                                              <span className='d-block fs-6 py-3'>
                                                <PopoverText
                                                  content={getEndUser(item)}
                                                  index={index}
                                                  className='desc-slicee'
                                                />
                                              </span>
                                            </td>
                                            {item?.sector_id != 2 ? (
                                              ''
                                            ) : (
                                              <td>
                                                <span className='d-block fs-6 py-3'>
                                                  {t(item.sector?.name)}
                                                </span>
                                              </td>
                                            )}
                                            <td>
                                              <span className='d-block fs-6 py-3'>
                                                {item.product_type_desc}
                                              </span>
                                            </td>
                                            <td>
                                              <span className='d-block fs-6 py-3'>
                                                {item.material_number?.slice(-7)}
                                              </span>
                                            </td>
                                            <td>
                                              <span className='d-block fs-6 py-3'>
                                                {item.product_name}
                                              </span>
                                            </td>
                                            <td>
                                              <span className='d-block fs-6 py-3'>
                                                <PopoverText
                                                  content={item.product_spec || '-'}
                                                  index={_index}
                                                  className='spec-sliceee'
                                                />
                                              </span>
                                            </td>
                                            {item?.sector_id != 2 && (
                                              <td>
                                                <span className='d-block fs-6 py-3'>
                                                  {i18next.language === 'en'
                                                    ? item.request_quantum?.toLocaleString('en', {
                                                        maximumFractionDigits: 4,
                                                      })
                                                    : item.request_quantum?.toLocaleString('id', {
                                                        maximumFractionDigits: 4,
                                                      })}{' '}
                                                  {item.sector_id === 3 ? ' MT' : ' Ton'}
                                                </span>
                                              </td>
                                            )}

                                            <td>
                                              <span className='d-block fs-6 py-3'>
                                                {i18next.language === 'en'
                                                  ? item.fixed_quantum?.toLocaleString('en', {
                                                      maximumFractionDigits: 4,
                                                    })
                                                  : item.fixed_quantum?.toLocaleString('id', {
                                                      maximumFractionDigits: 4,
                                                    })}{' '}
                                                {item.sector_id === 3 ? ' MT' : ' Ton'}
                                              </span>
                                            </td>

                                            {item?.sector_id != 2 && (
                                              <>
                                                {item.is_formulated_price ? (
                                                  <>
                                                    <td>
                                                      <span className='d-block fs-6 py-3'>
                                                        {t('Formulated Price')}
                                                      </span>
                                                    </td>
                                                  </>
                                                ) : (
                                                  <>
                                                    {item?.sector_id == 1 ? (
                                                      <>
                                                        <td>
                                                          <span className='d-block fs-6 py-3'>
                                                            {'Rp ' +
                                                              (i18next.language === 'en'
                                                                ? item.request_price?.toLocaleString(
                                                                    'en',
                                                                    {
                                                                      maximumFractionDigits: 4,
                                                                    }
                                                                  )
                                                                : item.request_price?.toLocaleString(
                                                                    'id',
                                                                    {
                                                                      maximumFractionDigits: 4,
                                                                    }
                                                                  ))}
                                                            /{item.sector_id === 3 ? ' MT' : ' Ton'}
                                                          </span>
                                                        </td>
                                                      </>
                                                    ) : (
                                                      <>
                                                        <td>
                                                          <span className='d-block fs-6 py-3'>
                                                            USD {PriceFormater(item.request_price)}{' '}
                                                            /MT
                                                          </span>
                                                        </td>
                                                      </>
                                                    )}
                                                  </>
                                                )}
                                              </>
                                            )}

                                            {item?.sector_id != 3 ? (
                                              <td>
                                                <span className='d-block fs-6 py-3'>
                                                  {'Rp' +
                                                    (i18next.language === 'en'
                                                      ? item.fixed_price?.toLocaleString('en', {
                                                          maximumFractionDigits: 4,
                                                        })
                                                      : item.fixed_price?.toLocaleString('id', {
                                                          maximumFractionDigits: 4,
                                                        }))}
                                                  /{item.sector_id === 3 ? ' MT' : ' Ton'}
                                                </span>
                                              </td>
                                            ) : (
                                              <td>
                                                <span className='d-block fs-6 py-3'>
                                                  USD {PriceFormater(item.fixed_price)} /MT
                                                </span>
                                              </td>
                                            )}
                                          </tr>
                                        )
                                      })}
                                      {/* End Table Head */}
                                    </TableUI.TBody>
                                  </TableUI.Table>
                                </TableUI.TableWrapper>
                              </TableUI.TableDetail>
                            </div>
                          </>
                          <hr/>

                          <div>
                            <Row>
                              <Col md={6}>
                                { data?.sip_reviewers?.length > 0 && <>
                                    <h4 className='mb-3'>{t('reviewer')}</h4>

                                    <ol style={{paddingLeft: '17px'}}>
                                      {
                                        data?.sip_reviewers?.map((item: any) => {
                                          return <li key={item.username}>{ [
                                            item.username,
                                            item.name,
                                          ].join(" - ") }</li>
                                        })
                                      }
                                    </ol>
                                </> }
                              </Col>
                              <Col md={6}>
                                { data?.sip_approvers?.length > 0 && <>
                                  <h4 className='mb-3'>{t('approver')}</h4>

                                  <ol style={{paddingLeft: '17px'}}>
                                    {
                                      data?.sip_reviewers?.map((item: any) => {
                                        return <li key={item.username}>{ [
                                          item.username,
                                          item.name,
                                        ].join(" - ") }</li>
                                      })
                                    }
                                  </ol>
                                </> }
                              </Col>
                            </Row>

                          </div>
                        </>
                      </Accordion.Body>
                    </Accordion.Item>
                  </>
                ))}
              </Accordion>
            </>
          )}
        </Modal.Body>
      </Modal>
    </>
  )
}

export default ListHistorySIP
